import React from 'react'
import CompletnessWidget from './menu-components/CompletnessWidget'
import Navigation from './menu-components/Navigation'

function EditMenu({setRecommendationSent}) {
  return (
    <div id="edit-menu">
        <CompletnessWidget />
        <Navigation setRecommendationSent={setRecommendationSent}/>
    </div>
  )
}

export default EditMenu